import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_MenuNodesTree = _resolveComponent("MenuNodesTree")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_MenuElementsDetail = _resolveComponent("MenuElementsDetail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.menuManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_KnFabButton, {
              icon: "fas fa-plus",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm())),
              "data-test": "open-form-button"
            })
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_MenuNodesTree, {
          elements: _ctx.menuNodes,
          loading: _ctx.loading,
          onDeleteMenuNode: _ctx.onNodeDelete,
          onSelectedMenuNode: _ctx.onNodeSelect,
          onUnselectedMenuNode: _ctx.onNodeUnselect,
          onChangeWithFather: _ctx.onChangeWithFather,
          onMoveUp: _ctx.onMoveUp,
          onMoveDown: _ctx.onMoveDown,
          "data-test": "menu-nodes-tree"
        }, null, 8, ["elements", "loading", "onDeleteMenuNode", "onSelectedMenuNode", "onUnselectedMenuNode", "onChangeWithFather", "onMoveUp", "onMoveDown"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.hideForm)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.menuManagement.title',
              hint: 'managers.menuManagement.hint'
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true),
        (!_ctx.hideForm)
          ? (_openBlock(), _createBlock(_component_MenuElementsDetail, {
              key: 1,
              selectedRoles: _ctx.selectedMenuNode.roles,
              parentNodeRoles: _ctx.parentNodeRoles,
              roles: _ctx.roles,
              selectedMenuNode: _ctx.selectedMenuNode,
              menuNodes: _ctx.menuNodes,
              staticPagesList: _ctx.staticPagesList,
              onRefreshRecordSet: _ctx.loadMenuNodes,
              onClosesForm: _ctx.closeForm,
              onDataChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dirty = true)),
              hidden: _ctx.hideForm
            }, null, 8, ["selectedRoles", "parentNodeRoles", "roles", "selectedMenuNode", "menuNodes", "staticPagesList", "onRefreshRecordSet", "onClosesForm", "hidden"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}